var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { $protocolKey } from 'zova';
import { BeanInterceptorBase, Interceptor } from 'zova-module-a-fetch';
export let InterceptorJwt = (_dec = Interceptor({
  dependencies: 'a-interceptor:headers'
}), _dec2 = __z_BeanInfo({
  module: "a-interceptor"
}), _dec(_class = _dec2(_class = class InterceptorJwt extends BeanInterceptorBase {
  constructor(...args) {
    super(...args);
    this._beanJwtAdapter = void 0;
    this._refreshAuthTokenPromise = void 0;
  }
  async __init__(_beanFetch, options) {
    const jwtAdapter = options.jwtAdapter || this.scope.config.jwtAdapter;
    const beanFullName = jwtAdapter.replace(':', '.service.');
    // singleton
    this._beanJwtAdapter = await this.app.bean._getBean(beanFullName, true);
  }
  async onRequest(config, options, next) {
    try {
      const accessToken = await this.prepareAccessToken(config, options.authToken);
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    } catch (error) {
      error.config = config;
      error.request = undefined;
      error.response = undefined;
      throw error;
    }
    return next(config);
  }
  async prepareAccessToken(config, authToken) {
    if (!this.sys.config.api.jwt) return;
    if (this.sys.config.ssr.cookieDisabledOnServer) return;
    // use default in scope.config rather than IInterceptorOptionsJwt.options
    const authTokenCurrent = authToken ?? this.scope.config.authToken.default;
    // authToken = authToken ?? this.scope.config.authToken.default;
    if (process.env.SERVER) {
      config.headers[$protocolKey('x-vona-jwt-authtoken')] = typeof authTokenCurrent === 'string' ? true : authTokenCurrent;
    }
    // // authToken: false
    // if (authTokenCurrent === false) return;
    // authToken: string
    if (typeof authTokenCurrent === 'string') return authTokenCurrent;
    // if (typeof authToken === 'string') return authToken;
    // authToken: true
    let jwtInfo = await this._beanJwtAdapter.getJwtInfo();
    if (!jwtInfo) {
      if (authToken === true) {
        this.app.throw(401); // 401 rather than 403
      }
      return;
    }
    // accessToken
    if (process.env.SERVER || !jwtInfo.expireTime || jwtInfo.expireTime > Date.now()) {
      if (!jwtInfo.accessToken) {
        if (authToken === true) this.app.throw(401);
        return;
      }
      return jwtInfo.accessToken;
    }
    // refreshToken
    if (!jwtInfo.refreshToken) {
      if (authToken === true) this.app.throw(401);
      return;
    } else {
      if (authToken === false) {
        // need not refreshAuthToken, such as captcha.create
        return;
      }
    }
    jwtInfo = await this._refreshAuthToken(jwtInfo.refreshToken);
    return jwtInfo.accessToken;
  }
  async _refreshAuthToken(refreshToken) {
    if (!this._refreshAuthTokenPromise) {
      this._refreshAuthTokenPromise = this._refreshAuthTokenInner(refreshToken);
    }
    return await this._refreshAuthTokenPromise;
  }
  async _refreshAuthTokenInner(refreshToken) {
    try {
      return await this._beanJwtAdapter.refreshAuthToken(refreshToken);
    } finally {
      this._refreshAuthTokenPromise = undefined;
    }
  }
}) || _class) || _class);